import { t } from 'i18next';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';

import { PCFRequestStatus } from '../../../../shared/enums/pcf-request';
import styles from './TaskStatus.module.css';

const determineTagClass = (status: PCFRequestStatus, taskStatus?: 'product' | 'component') => {
  switch (status) {
    case PCFRequestStatus.Complete:
    case PCFRequestStatus.Updated:
    case PCFRequestStatus.Outdated:
      return styles['complete-tag'];
    case PCFRequestStatus.Pending:
      return styles['pending-tag'];
    case PCFRequestStatus.Rejected:
      return taskStatus === 'product' ? styles['complete-tag'] : styles['rejected-tag']; // Product tasks that are rejected should be green
    default:
      return '';
  }
};

export const determineStatusText = (
  status: PCFRequestStatus,
  taskType?: 'product' | 'component',
) => {
  let text = '';

  if (
    taskType === 'product' &&
    [
      PCFRequestStatus.Complete,
      PCFRequestStatus.Rejected,
      PCFRequestStatus.Updated,
      PCFRequestStatus.Outdated,
    ].includes(status)
  ) {
    text = t('pcfRequest.complete');
  } else if (
    taskType === 'component' &&
    [PCFRequestStatus.Complete, PCFRequestStatus.Updated, PCFRequestStatus.Outdated].includes(
      status,
    )
  ) {
    text = t('pcfRequest.complete');
  } else {
    text = t(`pcfRequest.${status}`);
  }

  return text;
};

type TaskStatusProps = {
  status: PCFRequestStatus;
  taskType?: 'product' | 'component';
};

export default function TaskStatus({ status, taskType }: TaskStatusProps) {
  const text = determineStatusText(status, taskType);

  const tagClass = determineTagClass(status, taskType);

  return (
    <Tag rounded className={classNames('text-sm font-medium px-2 py-1', tagClass)}>
      {text}
    </Tag>
  );
}
